import { WishlistWithItemsSchema } from "@apps/wishlist/schemas/WishlistWithItemsSchema";
import { array, object } from "superstruct";

export const GetWishlistsResponseSchema = object({
    wishlistsWithItems: array(WishlistWithItemsSchema),
});
